<template>
  <v-carousel hide-delimiters height="90vh">
    <v-carousel-item
      v-for="(item, i) in items"
      contain
      :key="i"
      :src="item.src"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: require("../img/gallary/후보1.jpg"),
        },
        {
          src: require("../img/gallary/후보2.jpg"),
        },
        {
          src: require("../img/gallary/후보3.jpg"),
        },
        {
          src: require("../img/gallary/후보4.jpg"),
        },
        {
          src: require("../img/gallary/후보5.jpg"),
        },
        {
          src: require("../img/gallary/후보6.jpg"),
        },
        {
          src: require("../img/gallary/후보7.jpg"),
        },
        {
          src: require("../img/gallary/후보8.jpg"),
        },
        {
          src: require("../img/gallary/후보9.jpg"),
        },
        {
          src: require("../img/gallary/후보10.jpg"),
        },
        {
          src: require("../img/gallary/후보11.jpg"),
        },
        {
          src: require("../img/gallary/후보12.jpg"),
        },
        {
          src: require("../img/gallary/후보13.jpg"),
        },
        {
          src: require("../img/gallary/후보15.jpg"),
        },
        {
          src: require("../img/gallary/후보16.jpg"),
        },
        {
          src: require("../img/gallary/후보17.jpg"),
        },
        {
          src: require("../img/gallary/후보18.jpg"),
        },
        {
          src: require("../img/gallary/후보19.jpg"),
        },
        {
          src: require("../img/gallary/후보20.jpg"),
        },
        {
          src: require("../img/gallary/후보21.jpg"),
        },
        {
          src: require("../img/gallary/후보22.jpg"),
        },
        {
          src: require("../img/gallary/후보23.jpg"),
        },
        {
          src: require("../img/gallary/후보24.jpg"),
        },
        {
          src: require("../img/gallary/후보25.jpg"),
        },
        {
          src: require("../img/gallary/후보26.jpg"),
        },
        {
          src: require("../img/gallary/후보27.jpg"),
        },
        {
          src: require("../img/gallary/후보28.jpg"),
        },
      ],
    };
  },
};
</script>
